import React, { useState } from "react";
import { motion } from "framer-motion"; // Import framer-motion
import {
  UserIcon,
  ClipboardDocumentCheckIcon,
  DocumentTextIcon,
  BanknotesIcon,
  MegaphoneIcon,
  ShareIcon,
} from "@heroicons/react/24/outline";

const RegistrationSteps = () => {
  const [registrationType, setRegistrationType] = useState("charity");

  const steps = {
    charity: [
      { name: "Register", icon: UserIcon },
      { name: "Fill Charity Form", icon: ClipboardDocumentCheckIcon },
      { name: "Submit Charity Documents", icon: DocumentTextIcon },
      { name: "Add Bank Account", icon: BanknotesIcon },
      { name: "Create Campaign", icon: MegaphoneIcon },
      { name: "Share Campaign with Donors", icon: ShareIcon },
    ],
    individual: [
      { name: "Register", icon: UserIcon },
      { name: "Provide User Information", icon: ClipboardDocumentCheckIcon },
      { name: "Submit User Documents", icon: DocumentTextIcon },
      { name: "Create Campaign", icon: MegaphoneIcon },
      { name: "Share Campaign", icon: ShareIcon },
    ],
  };

  return (
    <motion.div
      className="min-h-screen h-full bg-cover bg-center flex flex-col items-center justify-center p-8 mt-20 "
      style={{
        backgroundImage: "url('https://img.freepik.com/free-photo/close-up-community-concept-with-hands_23-2148931127.jpg')",
      }}
      initial={{ opacity: 0, y: 50 }} 
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }} 
      transition={{
        duration: 1.5, 
        ease: "easeOut",
      }}
    >
      {/* Header */}
      <p className="text-lg text-gray-700 mb-12 text-center max-w-2xl bg-opacity-80 bg-white p-4 rounded-md">
        Choose your registration type and follow the steps to get started.
        Whether you're a charity or an individual, the process is simple and
        straightforward.
      </p>

      {/* Registration Type Selection */}
      <div className="flex gap-6 mb-10  " >
        <button
          className={`px-6 py-3 rounded-lg shadow-lg transform transition duration-300 ${registrationType === "charity" ? "bg-btn-1 text-white scale-105" : "bg-white text-gray-800"}`}
          onClick={() => setRegistrationType("charity")}
        >
          Charity
        </button>
        <button
          className={`px-6 py-3 rounded-lg shadow-lg transform transition duration-300 ${registrationType === "individual" ? "bg-btn-1 text-white scale-105" : "bg-white text-gray-800"}`}
          onClick={() => setRegistrationType("individual")}
        >
          Individual
        </button>
      </div>

      {/* Steps Display */}
      <div className="p-8 opacity-90 rounded-lg shadow-2xl w-full max-w-3xl bg-white bg-opacity-30 backdrop-blur-md">
        <h3 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
          Steps for {registrationType === "charity" ? "Charity" : "Individual"}
        </h3>
        <div className="space-y-6">
          {steps[registrationType].map((step, index) => (
            <motion.div
              key={index}
              className="flex items-center gap-4 p-4 bg-blue-50 border-l-4 border-blue-400 shadow-sm transform transition duration-500 hover:scale-105"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2, duration: 0.5 }}
            >
              {/* Icon */}
              <div className="bg-btn-1 text-white rounded-full w-12 h-12 flex items-center justify-center">
                <step.icon className="w-6 h-6" />
              </div>
              {/* Step Name */}
              <p className="text-gray-800 text-lg">{step.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default RegistrationSteps;
